import { PAYWALL_LOCAL_STORAGE_KEY } from "./authOperations";


declare const window: Window & {
  YitPaywall: {
    getPaywallData?: (key: string) => string | null;
    removePaywallData?: (key: string) => boolean;
    addPaywallData?: (key: string, data: any) => boolean;
  }
}

export const productClientId = 'newspaper';
export const ynetProductClientId = 'plus';


export function getCurrentUser() {
    const user = typeof window !== "undefined" && window && window.YitPaywall && typeof window.YitPaywall.getPaywallDataObj === "function" && window.YitPaywall.getPaywallDataObj();
   if(user) {
       return user;
   }
}

export function removeCurrentUser() {
    typeof window !== "undefined" && window && window.YitPaywall && typeof window.YitPaywall.removePaywallDataObj === "function" && window.YitPaywall.removePaywallDataObj();
}

export function getUsernameFromEmail(email:string) {
    return typeof email === 'string' && email.includes('@')
      ? email.split('@')[0]
      : 'משתמש';
  }

  function getDisplayName(user) {
    const firstName = user.firstname && user.firstname.value ? user.firstname.value.trim() : '';
    const email = user.email && user.email.value ? user.email.value : '';
  
    if (firstName) {
      return `${firstName}`;
    } else {
      return getUsernameFromEmail(email);
    }
  }


export function setCurrentUser(user) {
    const paywallObject = {
        displayName: getDisplayName(user)
    }
    typeof window !== "undefined" && window && window.YitPaywall && typeof window.YitPaywall.addPaywallDataObj === "function" && window.YitPaywall.addPaywallDataObj(PAYWALL_LOCAL_STORAGE_KEY, paywallObject);
}



function getDisplayNameFromCustomerDetails(customerDetails) {
    const firstName = customerDetails.firstname || '';
    const email = customerDetails.email || '';

    if (firstName) {
        return `${firstName}`;
    } else {
        return getUsernameFromEmail(email);
    }
}


export function updateCurrentUserDisplayName(user) {
    const existingData = getCurrentUser() || {};
    const updatedPaywallObject = {
        ...existingData,
        displayName: getDisplayNameFromCustomerDetails(user)
    }
    typeof window !== "undefined" && window && window.YitPaywall && typeof window.YitPaywall.addPaywallDataObj === "function" && window.YitPaywall.addPaywallDataObj(PAYWALL_LOCAL_STORAGE_KEY, updatedPaywallObject);
}

export const hasProductClientId = (claims, productClientId) => {
  if (!Array.isArray(claims)) {
      console.error('Claims should be an array.');
      return false;
  }
  return claims.some(claim => claim === productClientId);
}

export function getUserLabel(displayName: string): string {
  if (!displayName) return 'משתמש';
  return displayName.includes('@') ? getUsernameFromEmail(displayName) : displayName;
}